import React, { createContext, useContext, useState, useEffect, useMemo } from "react";
import axios from "axios";
import { getToken } from "../utils/tokenUtils";

const GroupedCandidatesContext = createContext();

export const GroupedCandidatesProvider = ({ children }) => {
  const [groupedCandidates, setGroupedCandidates] = useState({
    Selected: [],
    Shortlisted: [],
    Pending: [],
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const API_URL = "https://hrmspayroll.prepstripe.com/api/grouped-by-status";
  const token = getToken();

  // Fetch grouped candidates from API
  const fetchGroupedCandidates = async () => {
    setLoading(true);
    try {
      const response = await axios.get(API_URL, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }); 
      const data = response.data?.candidates || {};
      
      setGroupedCandidates({
        Selected: data.Selected || [],
        Shortlisted: data.Shortlisted || [],
        Pending: data.Pending || [],
      });
      setError(null);
    } catch (err) {
      console.error("Error fetching grouped candidates:", err.message);
      setError("Failed to load grouped candidates");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGroupedCandidates(); // Load grouped candidates at startup
  }, []);

  // Memoize the context value
  const value = useMemo(
    () => ({
      groupedCandidates,
      shortlistedCandidates: groupedCandidates.Shortlisted || [],
      loading,
      error,
      fetchGroupedCandidates,
    }),
    [groupedCandidates, loading, error]
  );

  return (
    <GroupedCandidatesContext.Provider value={value}>
      {children}
    </GroupedCandidatesContext.Provider>
  );
};

// Custom hook to access the GroupedCandidatesContext
export const useGroupedCandidates = () => useContext(GroupedCandidatesContext);

